import {
  GraphQLObjectType,
  GraphQLString,
  GraphQLBoolean,
  GraphQLInt,
  GraphQLList,
  GraphQLNonNull,
  GraphQLID,
  GraphQLFloat
} from 'graphql';

import { connectionArgs, connectionFromArray, toGlobalId } from 'graphql-relay';

import AssignInfoType from './assignInfo.gql';
import CoursePerformanceType from './coursePerformance.gql';
import CoursePrerequisiteType from './coursePrerequisite.gql';
import CurriculumType from './curriculum.gql';
import UserType from './user.gql';
import FeedbackType from './feedback.gql';
import TagType from './tag.gql';
import Node from './node.gql';
import OrderOfCompletionEnumType from './enums/orderOfCompletionEnum.gql';

import sectionConnection from '../connections/sectionType';

const courseType = new GraphQLObjectType({
  name: 'Course',
  fields: () => ({
    id: {
      type: new GraphQLNonNull(GraphQLID),
      resolve: root => toGlobalId('Course', root.pid)
    },
    pid: {
      type: GraphQLString
    },
    image: {
      type: GraphQLString
    },
    name: {
      type: GraphQLString
    },
    deactivateFrom: {
      type: GraphQLString
    },
    prerequisites: {
      type: new GraphQLList(CoursePrerequisiteType)
    },
    orderOfCompletion: {
      type: OrderOfCompletionEnumType
    },
    totalAssignments: {
      type: GraphQLInt
    },
    totalCards: {
      type: GraphQLInt
    },
    assignInfo: {
      type: AssignInfoType,
      args: {
        userId: {
          type: GraphQLString
        }
      }
    },
    coursePerformance: {
      type: CoursePerformanceType,
      args: {
        userId: {
          type: GraphQLString
        }
      }
    },
    curriculum: {
      type: CurriculumType
    },
    courseTags: {
      type: new GraphQLList(TagType),
      resolve: item => item.courseTags.slice()
    },
    sections: {
      type: sectionConnection,
      args: connectionArgs,
      resolve: (item, args) => connectionFromArray(item.sections, args)
    },
    description: {
      type: GraphQLString
    },
    duration: {
      type: GraphQLFloat
    },
    feedback: {
      type: FeedbackType
    },
    certificateEnabled: {
      type: GraphQLBoolean
    },
    badge: {
      type: GraphQLString
    },
    teachers: {
      type: new GraphQLList(UserType),
      resolve: () => []
    },
    user: {
      type: UserType,
      args: {
        id: {
          type: GraphQLString
        }
      }
    },
    immediateCoach: {
      type: new GraphQLList(UserType),
      args: {
        userId: {
          type: GraphQLString
        }
      },
      resolve: item => item.immediateCoach.slice()
    },
    channel: {
      type: GraphQLBoolean
    },
    companyId: {
      type: GraphQLString
    },
    lastContentUpdated: {
      type: GraphQLString
    },
    allCurriculums: {
      type: new GraphQLList(CurriculumType),
      resolve: item => item.allCurriculums.slice()
    },
    criteria: {
      type: GraphQLString
    },
    cardLockData: {
      type: GraphQLString
    },
    contributeToSuccessStatus: {
      type: GraphQLBoolean
    },
    isGradable: {
      type: GraphQLBoolean
    },
    filters: {
      type: new GraphQLList(GraphQLString),
      resolve: item => {
        const rFiltersArray = [];
        item.filters.forEach((rFilterObject, index) => {
          rFiltersArray[index] = rFilterObject.value;
        });
        return rFiltersArray;
      }
    },
    progressWeight: {
      type: GraphQLFloat
    },
    deleted: {
      type: GraphQLBoolean
    }
  }),
  interfaces: [Node.nodeInterface]
});

window[courseType.name + 'GQLType'] = courseType;

export default courseType;
